import React, { Component } from 'react';
import { connect } from 'react-redux';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import Notification from 'material-ui/svg-icons/social/notifications-none'
import SocialNotificationsActive from 'material-ui/svg-icons/social/notifications-active'
import { fetchNotifications, updateNotifications } from '../../actions';
import MenuItem from 'material-ui/MenuItem';
import { convertText } from '../../common/node'
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export class NotificationsIconMenu extends Component {

  handleClick() {
    if(this.props.server.notification_red) {
      this.props.updateNotifications();
    }
  }

  render() {
    if(cookies.get('api_access_token') === 'undefined' || cookies.get('api_access_token') == null) {
      return <div />
    }
    const loc = cookies.get('locale')
    const { server } = this.props;

    let notifications = []
    for(let i in server.notifications){
      notifications.push(<MenuItem
        style={{ background: `${messageBackground(server.notifications[i].status)}` }}
        primaryText={`${this.message(server.notifications[i], loc)}`}
        containerElement={<a href={`../nodes/${server.notifications[i].node.id}`}> </a>}
        />)
    }
    return (
      <div>
        <IconMenu
          desktop={true}
          iconButtonElement={
          <IconButton style={{height: '30px', padding: 0}}>
            { (server.notification_red)
                ? ( <SocialNotificationsActive color="#cb0000"/> )
                : ( <Notification color="#606060"/> )
            }
          </IconButton>
        }
        onClick={this.handleClick.bind(this)}
      >
        {notifications}
      </IconMenu>
      </div>
    )
  }

  componentDidMount() {
    if(cookies.get('api_access_token') === 'undefined' || cookies.get('api_access_token') == null) {
      return
    }
    this.props.fetchNotifications();
  }

  message = (notification, loc) => {
    switch(notification.message) {
      case 'like':
        return this.likeMessage(notification, loc)
      case 'add':
        return this.addMessage(notification, loc)
      case 'stamp':
        return this.stampMessage(notification, loc)
      default:
        return null
    }
  }

  likeMessage = (notification, loc) => {
    if(loc === 'en') {
      return `${notification.from.name} liked your node: "${nodeText(notification.node.text)}"`
    } else {
      return `${notification.from.name}さんがあなたの「${nodeText(notification.node.text)}」をLikeしました`
    }
  }

  addMessage = (notification, loc) => {
    if(loc === 'en') {
      return `${notification.from.name} posted a node under your node: "${nodeText(notification.node.text)}"`
    } else {
      return `${notification.from.name}さんがあなたの「${nodeText(notification.node.text)}」に子ノードを追加しました`
    }
  }

  stampMessage = (notification, loc) => {
    if(loc === 'en') {
      return `Stamp of your node: "${nodeText(notification.node.text)}" was updated`
    } else {
      return `あなたの「${nodeText(notification.node.text)}」の評価スタンプが更新されました`
    }
  }
}

const nodeText = text =>(
  convertText(text).substr(0,20)
  // text.substr(0,20).replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
)

const messageBackground = status => {
  switch(status) {
    case 'notified':
      return '#F5F5F5'
    case 'viewed':
      return '#707070'
    default:
      return null
  }
}

const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

const mapDispatchToProps = {
  fetchNotifications,
  updateNotifications
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsIconMenu)



// WEBPACK FOOTER //
// ./src/components/fixedComponents/NotificationsIconMenu.js